import React, { FC } from 'react';

import s from '../styles.scss';

export const HelpCenterIconSvg: FC = () => (
  <svg
    className={s.svgIcon}
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M44.83 36H15.83L16.63 12.87C16.6453 12.1136 16.9526 11.3925 17.4875 10.8576C18.0225 10.3226 18.7436 10.0153 19.5 10H43C43.3633 10.0019 43.7224 10.0776 44.0555 10.2227C44.3887 10.3678 44.6888 10.5791 44.9376 10.8438C45.1864 11.1086 45.3788 11.4212 45.503 11.7627C45.6272 12.1041 45.6806 12.4673 45.66 12.83L44.83 36Z"
      fill="#28BF9A"
    />
    <path
      d="M49.66 40.6702H10.66L11.46 17.8002C11.4935 17.0476 11.8155 16.3368 12.3592 15.8154C12.903 15.294 13.6267 15.002 14.38 15.0002H47.74C48.1053 14.9958 48.4675 15.0659 48.8048 15.2061C49.1421 15.3462 49.4473 15.5537 49.7018 15.8156C49.9563 16.0776 50.1548 16.3887 50.2851 16.7299C50.4155 17.0711 50.475 17.4353 50.46 17.8002L49.66 40.6702Z"
      fill="#116DFF"
    />
    <path
      d="M53.27 52.0001H5.27002L6.27002 22.8901C6.29851 22.1137 6.62711 21.3786 7.18666 20.8395C7.74621 20.3005 8.49307 19.9996 9.27002 20.0001H51.5C51.8754 19.997 52.2474 20.0704 52.5934 20.216C52.9393 20.3615 53.252 20.5761 53.5122 20.8466C53.7724 21.1171 53.9747 21.4379 54.1067 21.7892C54.2387 22.1406 54.2977 22.5152 54.28 22.8901L53.27 52.0001Z"
      fill="#C2E2FF"
    />
    <path d="M31.72 39H9.71997L10.11 28H32.1L31.72 39Z" fill="white" />
    <path
      d="M12.98 31H22.98V32H12.98V31ZM12.84 35H28.84V36H12.84V35Z"
      fill="#192C55"
    />
  </svg>
);
